<template>
  <a-modal v-model:open="computedShowModal"
           width="600px"
           :closable="false"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
  >
    <div class="modal-content-body">
      <div class="search-client-header">
        <div class="modal-title">
          주소 검색
        </div>
        <button
            type="button"
            class="btn-close"
            @click="uiHandler.closeModal"
        >
          <i class="fa-regular fa-x"/>
        </button>
      </div>
      <div class="search-client-body">

      </div>
    </div>
  </a-modal>
</template>
<script>
import {
  logging,
  oneBtnDialog,
  businessNumberFormatter, jwtDecoder,
} from '@/utils/utils';
import NoResult from '@/views/components/NoResult';
import Pagination from '@/views/components/Pagination';
import {EmitEvents} from "@/views/ContractManagement/contracts/dentium/EmitEvents";
import {localStorageEnums} from "@/enums/localStorage.enums";

export default {
  components: {
    Pagination,
    NoResult,
  },
  emits: Object.keys({...EmitEvents.ClientModal, ...EmitEvents.Common}),
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    searchType: {
      type: String,
      required: false,
      default: 'HOSPITAL'
    }
  },
  computed: {
    computedShowModal() {
      return this.showModal;
    },
    computedNoResultMessage() {
      return this.$i18n.t('noresult_search');
    },
    formToParam() {
      const {searchParam} = this
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = 10;
      obj.type = this.searchType;
      if (this.searchType === 'HOSPITAL' && !searchParam.condition) {
        const data = JSON.parse(localStorage.getItem(localStorageEnums.CompanyInfo));
        obj.username = data?.accountInfo?.username;
      }
      if (searchParam?.condition) {
        if (typeof searchParam.condition === "string") {
          obj.search = 'name'
        }
        if (typeof searchParam.condition === "number") {
          obj.search = 'cNo'
        }
        obj.condition = searchParam.condition;
      }
      return obj
    }
  },
  data() {
    return {
      businessNumberFormatter,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      searchParam: {
        search: '', // 숫자일때: cNo(사업자 번호), 문자일때: name(병원명)
        condition: '',
        username: ''
      },
      paginationData: {
        listSize: 0,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
      },
      selectedItem: {},
      result: {
        list: [],
        totalDocs: 0,
      },
    }
  },
  mounted() {
    this.uiHandler.getClientList()
  },
  methods: {
    ui() {
      const paginationHandler = async (childPassParam) => {
        this.paginationData.currentPage = childPassParam.page;
        await this.uiHandler.getClientList();
      }
      const joinHospitalInfo = (item) => {
        const array = [
          item.ceo,
          businessNumberFormatter(item.cNo),
        ];

        let address = '';
        if (item.bizAddr) {
          address = item.bizAddr;
        } else if (item.addrOne && item.addrTwo && item.addrThree) {
          address = `${item.addrOne} ${item.addrTwo} ${item.addrThree}`;
        }

        if (item.addrDetail) address += ` ${item.addrDetail}`;

        if (address) array.push(address)

        return array.join(', ');
      }

      const chooseItem = (index) => {
        if (this.result.list[index].isSelected) return;
        this.result.list.forEach((item, i) => {
          if (index !== i) item.isSelected = false;
        });
        this.result.list[index].isSelected = true;
        this.selectedItem = this.result.list[index];
      }
      const search = async () => {
        this.paginationData.currentPage = 1;
        await this.uiHandler.getClientList();
      }
      const validateData = async () => {
        const selectedItem = this.selectedItem;
        if (!selectedItem.isSelected) {
          await oneBtnDialog('거래처 미선택', '거래처를 선택해 주세요.', false);
          return {status: false};
        }

        return {status: true, selectedItem};
      }
      return {
        getClientList: async () => {
          await this.apiHandler.getClientList(this.formToParam, async (response) => {
            if (response.data.message) {
              await oneBtnDialog('검색어 오류', '검색어에 특수문자를 포함할 수 없습니다.', false);
              return;
            }

            console.log("1 1231231==>", response.data.docs)

            if (jwtDecoder(localStorage.getItem('accessTokenManu')) === process.env.VUE_APP_POINT_IMPLANT) { // todo 임시코드
              console.log("2 1231231==>", response.data.docs)
              this.result.list = response.data.docs.filter(l => l.name === '서티치과');
            } else {
              console.log("3 1231231==>", response.data.docs)
              this.result.list = response.data.docs;
            }

            this.result.list = response.data.docs;
            this.result.totalDocs = response.data.totalDocs;
            this.paginationData.totalPages = response.data.totalPages;
            for (let i = 0; i < this.result.list.length; i++) {
              const item = this.result.list[i];
              item.convertedHospitalInfo = joinHospitalInfo(item);
              item.isSelected = false;
            }
          }, async (error) => {
            await oneBtnDialog(this.$i18n.t('hospital_list_err_title'), this.$i18n.t('hospital_list_err_content'), false);
          })
        },
        chooseItem,
        paginationHandler,
        emitClient: async () => {
          const result = await validateData();
          if (!result.status) return;
          await this.$emit(EmitEvents.ClientModal.CompleteSearch, result.selectedItem);
        },
        search,
        closeModal: () => {
          this.$emit(EmitEvents.Common.CloseModal, false);
        }
      }
    },
    api() {
      return {
        getClientList: async (params, success, fail) => {
          this.$store.commit('setIsLoading', true);
          return this.$apiInstance.post(`/companies/list/contract/v2`, params)
              .then((response) => {
                success(response);
              }, (error) => {
                console.log(error);
                fail(error);
              }).finally(() => this.$store.commit('setIsLoading', false));
        },
      }
    },
    /*
      달력 패키지로 생일 선택 시 포맷팅
    */

  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/search-client-modal.scss';
</style>
